/* ============================================================
   MUD THEORY - theme.js (vanilla, no dependencies)
   ============================================================ */
(function(){
  "use strict";
  var T = window.MudTheory || {};
  var $ = function(s, c){ return (c||document).querySelector(s); };
  var $$ = function(s, c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents){
    var value = (cents/100);
    var fmt = T.money_format || "${{amount}}";
    function withComma(n){ return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
    function withCommaNoDecimal(n){ return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, name){
      switch(name){
        case "amount": return withComma(value);
        case "amount_no_decimals": return withCommaNoDecimal(value);
        case "amount_with_comma_separator": return value.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        case "amount_no_decimals_with_comma_separator": return withCommaNoDecimal(value);
        default: return withComma(value);
      }
    });
  }
  window.MTformatMoney = formatMoney;

  /* ---------- Reveal animations ---------- */
  function initReveal(){
    if(!document.body.classList.contains("anim-on")) return;
    var els = $$(".reveal:not(.in), .stagger:not(.in)");
    if(!("IntersectionObserver" in window) || !els.length){ els.forEach(function(e){ e.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold:.12, rootMargin:"0px 0px -7% 0px" });
    els.forEach(function(e){ io.observe(e); });
  }

  /* ---------- Header scroll ---------- */
  function initHeader(){
    var h = $(".header"); if(!h) return;
    var on = function(){ h.classList.toggle("scrolled", window.scrollY > 12); };
    on(); window.addEventListener("scroll", on, { passive:true });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu(){
    var menu = $("#MobileMenu");
    document.addEventListener("click", function(e){
      if(e.target.closest("[data-menu-open]")){ menu && menu.classList.add("show"); document.body.style.overflow="hidden"; }
      if(e.target.closest("[data-menu-close]") || e.target === menu){ menu && menu.classList.remove("show"); document.body.style.overflow=""; }
    });
  }

  /* ---------- Cart ---------- */
  var drawer = { el:null, scrim:null };
  function openCart(){ if(T.cart_type==="page"){ window.location.href = T.routes.cart; return; } drawer.el && drawer.el.classList.add("show"); drawer.scrim && drawer.scrim.classList.add("show"); document.body.style.overflow="hidden"; }
  function closeCart(){ drawer.el && drawer.el.classList.remove("show"); drawer.scrim && drawer.scrim.classList.remove("show"); document.body.style.overflow=""; }

  function renderCart(cart){
    var count = cart.item_count;
    $$(".cart-count").forEach(function(c){ c.textContent = count; c.style.display = count>0 ? "" : "none"; });
    // free shipping bar (always, from $0)
    if(T.free_bar){
      var bar = $("#ShipBar");
      if(bar){
        var remain = Math.max(0, T.free_threshold - cart.total_price);
        var pct = T.free_threshold > 0 ? Math.min(100, (cart.total_price / T.free_threshold) * 100) : 100;
        var txt = $("#ShipBarTxt"), fill = $("#ShipBarFill");
        if(txt){ txt.innerHTML = remain > 0 ? ("You are <b>" + formatMoney(remain) + "</b> away from free shipping") : "<b>Free shipping unlocked.</b> Nicely done."; }
        if(fill){ fill.style.width = pct + "%"; }
      }
    }
    var body = $("#CartBody"); if(!body) return;
    if(count === 0){
      body.innerHTML = '<div class="cart-empty">'+icon("bag")+'<div><div class="serif" style="font-size:24px;margin-bottom:6px">Your ritual is empty</div><p style="font-size:14px;max-width:26ch;margin:0 auto">Four steps. Everything your skin needs, nothing it does not.</p></div><button class="btn btn--brown" data-cart-close>Start the ritual</button></div>';
      var foot = $("#CartFoot"); if(foot) foot.style.display="none";
      return;
    }
    var foot = $("#CartFoot"); if(foot) foot.style.display="";
    var lines = cart.items.map(function(it){
      var img = it.image ? '<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/, "_120x$1$2")+'" alt="'+escapeHtml(it.product_title)+'" loading="lazy">' : "";
      var meta = (it.options_with_values||[]).filter(function(o){ return o.value !== "Default Title"; }).map(function(o){ return o.value; }).join(" / ");
      var compare = (it.original_line_price > it.final_line_price) ? '<s>'+formatMoney(it.original_line_price)+'</s>' : "";
      return '<div class="cart-line" data-key="'+it.key+'">'+
        '<a class="cart-line__media" href="'+it.url+'">'+img+'</a>'+
        '<div style="flex:1;min-width:0">'+
          '<div class="cart-line__name">'+escapeHtml(it.product_title)+'</div>'+
          '<div class="cart-line__meta">'+escapeHtml(meta)+'</div>'+
          '<div class="cart-line__bottom">'+
            '<div class="qty"><button data-qty-down aria-label="Decrease">'+icon("minus")+'</button><span>'+it.quantity+'</span><button data-qty-up aria-label="Increase">'+icon("plus")+'</button></div>'+
            '<div class="price"><b>'+formatMoney(it.final_line_price)+'</b>'+compare+'</div>'+
          '</div>'+
          '<button class="cart-line__rm" data-remove>Remove</button>'+
        '</div></div>';
    }).join("");
    body.innerHTML = lines;
    var sub = $("#CartSubtotal"); if(sub) sub.textContent = formatMoney(cart.total_price);
    var checkout = $("#CartCheckout"); if(checkout) checkout.textContent = "Checkout · " + formatMoney(cart.total_price);
    // hide upsells already in cart
    var ids = cart.items.map(function(i){ return i.product_id; });
    $$("[data-upsell-product]").forEach(function(u){ u.style.display = ids.indexOf(parseInt(u.getAttribute("data-upsell-product"),10)) > -1 ? "none" : ""; });
  }

  function fetchCart(){ return fetch(T.routes.cart + ".js", { headers:{ "Accept":"application/json" } }).then(function(r){ return r.json(); }); }
  function refreshCart(){ return fetchCart().then(renderCart); }

  function addToCart(id, qty, sellingPlan){
    var item = { id:id, quantity: qty||1 };
    if(sellingPlan){ item.selling_plan = sellingPlan; }
    return fetch(T.routes.cart_add + ".js", {
      method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ items:[item] })
    }).then(function(r){ return r.json(); }).then(function(){ return refreshCart(); }).then(function(){ openCart(); });
  }
  function changeLine(key, qty){
    return fetch(T.routes.cart_change + ".js", {
      method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ id:key, quantity:qty })
    }).then(function(r){ return r.json(); }).then(renderCart);
  }

  function initCart(){
    drawer.el = $("#CartDrawer"); drawer.scrim = $("#CartScrim");
    document.addEventListener("click", function(e){
      var openBtn = e.target.closest("[data-cart-open]");
      if(openBtn){ e.preventDefault(); openCart(); return; }
      if(e.target.closest("[data-cart-close]") || e.target === drawer.scrim){ closeCart(); return; }
      var add = e.target.closest("[data-add-variant]");
      if(add){ e.preventDefault(); var vid = add.getAttribute("data-add-variant"); add.classList.add("is-loading"); addToCart(vid, 1).finally(function(){ add.classList.remove("is-loading"); }); return; }
      var line = e.target.closest(".cart-line");
      if(line){
        var key = line.getAttribute("data-key");
        var span = line.querySelector(".qty span");
        var q = parseInt(span ? span.textContent : "1", 10);
        if(e.target.closest("[data-qty-up]")){ changeLine(key, q+1); }
        if(e.target.closest("[data-qty-down]")){ changeLine(key, q-1); }
        if(e.target.closest("[data-remove]")){ changeLine(key, 0); }
      }
    });
    document.addEventListener("keydown", function(e){ if(e.key === "Escape"){ closeCart(); } });
    refreshCart();
  }

  /* ---------- Product form (PDP add to cart) ---------- */
  function initProductForm(){
    var form = $("#ProductForm");
    if(!form || form.dataset.submitBound) return;
    form.dataset.submitBound = "1";
    form.addEventListener("submit", function(e){
      e.preventDefault();
      var btn = form.querySelector("[type=submit]");
      var idInput = form.querySelector("[name=id]");
      var qtyInput = form.querySelector("[name=quantity]");
      var planInput = form.querySelector("[data-selling-plan-input]");
      var plan = planInput && planInput.value ? planInput.value : null;
      if(!idInput || !idInput.value) return;
      btn && btn.classList.add("is-loading");
      addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value,10) : 1, plan).finally(function(){ btn && btn.classList.remove("is-loading"); });
    });
  }

  /* ---------- Product buy box (variants + bundle offers + subscribe) ---------- */
  function initProductBuy(){
    $$("[data-product-root]").forEach(function(root){
      var form = $("#ProductForm", root);
      if(!form || form.dataset.bound) return; form.dataset.bound = "1";
      var data; try{ data = JSON.parse($("[data-variant-json]", root).textContent); }catch(err){ data = { variants:[] }; }
      var idInput = $("[name=id]", form);
      var planInput = $("[data-selling-plan-input]", form);
      var picker = $("[data-variant-picker]", root);
      var subs = $("[data-subs]", root);
      var submit = $("[type=submit]", form);
      var addLabel = (submit && submit.getAttribute("data-add-label")) || "Add to cart";

      var state = {
        offer: "single",
        bundleVariant: null, bundlePrice: 0, bundleCompare: 0,
        singleVariant: (idInput && idInput.value) || (data.variants[0] && data.variants[0].id),
        plan: ""
      };

      function single(){ return data.variants.find(function(v){ return String(v.id) === String(state.singleVariant); }) || data.variants[0] || {}; }

      function apply(){
        var price, compare, available = true, variantId;
        if(state.offer === "bundle"){
          variantId = state.bundleVariant; price = state.bundlePrice; compare = state.bundleCompare;
        } else {
          var v = single(); variantId = v.id; compare = v.compare_at_price; available = v.available !== false;
          if(state.plan){
            var pEl = $('[name=mt-plan][data-plan="' + state.plan + '"]', root);
            price = pEl ? parseInt(pEl.getAttribute("data-price"), 10) : v.price;
          } else { price = v.price; }
        }
        if(idInput && variantId != null) idInput.value = variantId;
        if(planInput) planInput.value = (state.offer === "single") ? state.plan : "";
        $$("[data-price-now]", root).forEach(function(n){ n.textContent = formatMoney(price); });
        var wasEl = $("[data-price-was]", root);
        if(wasEl){ if(compare && compare > price){ wasEl.textContent = formatMoney(compare); wasEl.style.display=""; } else { wasEl.style.display="none"; } }
        $$("[data-atc-price]", root).forEach(function(n){ n.textContent = formatMoney(price); });
        if(submit){
          var lbl = submit.querySelector("[data-atc-label]");
          if(available){ submit.removeAttribute("disabled"); if(lbl) lbl.textContent = addLabel; }
          else { submit.setAttribute("disabled","true"); if(lbl) lbl.textContent = "Sold out"; }
        }
        if(picker) picker.style.display = (state.offer === "bundle") ? "none" : "";
        if(subs) subs.style.display = (state.offer === "bundle") ? "none" : "";
      }

      if(picker){
        picker.addEventListener("click", function(e){
          var opt = e.target.closest(".variant-opt"); if(!opt) return;
          var group = opt.closest("[data-option-index]");
          $$(".variant-opt", group).forEach(function(o){ o.classList.remove("active"); });
          opt.classList.add("active");
          var vals = $$(".variant-opt.active", picker).map(function(o){ return o.getAttribute("data-value"); });
          var v = data.variants.find(function(vv){ return vv.options.join("~~~") === vals.join("~~~"); });
          if(v){
            state.singleVariant = v.id;
            var so = $('[name=mt-offer][data-offer-type="single"]', root);
            if(so){ so.setAttribute("data-variant", v.id); so.setAttribute("data-price", v.price); }
          }
          apply();
        });
      }

      $$('[name=mt-offer]', root).forEach(function(r){
        r.addEventListener("change", function(){
          state.offer = r.getAttribute("data-offer-type");
          if(state.offer === "bundle"){
            state.bundleVariant = r.getAttribute("data-variant");
            state.bundlePrice = parseInt(r.getAttribute("data-price"), 10);
            state.bundleCompare = parseInt(r.getAttribute("data-compare"), 10) || 0;
          }
          $$(".pdp-offer", root).forEach(function(l){ l.classList.remove("is-active"); });
          var lab = r.closest(".pdp-offer"); if(lab) lab.classList.add("is-active");
          apply();
        });
      });

      $$('[name=mt-plan]', root).forEach(function(r){
        r.addEventListener("change", function(){
          state.plan = r.getAttribute("data-plan") || "";
          $$(".pdp-sub", root).forEach(function(l){ l.classList.remove("is-active"); });
          var lab = r.closest(".pdp-sub"); if(lab) lab.classList.add("is-active");
          apply();
        });
      });

      apply();
    });
  }

  /* ---------- PDP gallery ---------- */
  function initGallery(){
    $$("[data-gallery]").forEach(function(g){
      var imgs = $$(".pdp-gallery__main img", g);
      var thumbs = $$(".pdp-thumb", g);
      var i = 0;
      function show(n){ i = (n + imgs.length) % imgs.length; imgs.forEach(function(im,k){ im.classList.toggle("active", k===i); }); thumbs.forEach(function(t,k){ t.classList.toggle("active", k===i); }); }
      thumbs.forEach(function(t,k){ t.addEventListener("click", function(){ show(k); }); });
      var prev = $(".pdp-gallery__nav--prev", g), next = $(".pdp-gallery__nav--next", g);
      prev && prev.addEventListener("click", function(){ show(i-1); });
      next && next.addEventListener("click", function(){ show(i+1); });
      show(0);
    });
  }

  /* ---------- Before/After ---------- */
  function initBeforeAfter(){
    $$(".ba").forEach(function(ba){
      var before = $(".ba__before", ba), handle = $(".ba__handle", ba);
      var dragging = false;
      function set(clientX){
        var r = ba.getBoundingClientRect();
        var p = Math.max(0, Math.min(100, ((clientX - r.left)/r.width)*100));
        before.style.clipPath = "inset(0 " + (100-p) + "% 0 0)";
        handle.style.left = p + "%";
      }
      ba.addEventListener("mousedown", function(e){ dragging=true; set(e.clientX); });
      ba.addEventListener("touchstart", function(e){ dragging=true; if(e.touches[0]) set(e.touches[0].clientX); }, {passive:true});
      window.addEventListener("mousemove", function(e){ if(dragging) set(e.clientX); });
      window.addEventListener("touchmove", function(e){ if(dragging && e.touches[0]) set(e.touches[0].clientX); }, {passive:true});
      window.addEventListener("mouseup", function(){ dragging=false; });
      window.addEventListener("touchend", function(){ dragging=false; });
      ba.addEventListener("keydown", function(e){
        var cur = parseFloat(handle.style.left) || 50;
        if(e.key==="ArrowLeft"){ var r=ba.getBoundingClientRect(); set(r.left + r.width*(cur-4)/100); e.preventDefault(); }
        if(e.key==="ArrowRight"){ var r2=ba.getBoundingClientRect(); set(r2.left + r2.width*(cur+4)/100); e.preventDefault(); }
      });
    });
  }

  /* ---------- Mobile swipe scrollers with dots ---------- */
  function initMobileScrollers(){
    $$(".results-grid, .ritual-steps, .treats-grid, #theory .g3, #ritual .prod-grid, .atlas-grid").forEach(function(grid){
      if(grid.dataset.carousel) return; grid.dataset.carousel = "1";
      var cards = Array.prototype.slice.call(grid.children).filter(function(c){ return c.nodeType === 1; });
      if(cards.length < 2) return;
      var dots = document.createElement("div"); dots.className = "results-dots";
      cards.forEach(function(_, i){
        var d = document.createElement("button"); d.type = "button"; d.className = "results-dot";
        d.setAttribute("aria-label", "Go to item " + (i + 1));
        d.addEventListener("click", function(){ cards[i].scrollIntoView({ behavior:"smooth", inline:"center", block:"nearest" }); });
        dots.appendChild(d);
      });
      grid.parentNode.insertBefore(dots, grid.nextSibling);
      function update(){
        if(grid.scrollWidth <= grid.clientWidth + 4){ dots.style.display = "none"; return; }
        dots.style.display = "flex";
        var box = grid.getBoundingClientRect(), center = box.left + box.width / 2, best = 0, bd = 1e9;
        cards.forEach(function(c, i){ var r = c.getBoundingClientRect(), cc = r.left + r.width / 2, dd = Math.abs(cc - center); if(dd < bd){ bd = dd; best = i; } });
        $$(".results-dot", dots).forEach(function(d, i){ d.classList.toggle("active", i === best); });
      }
      grid.addEventListener("scroll", update, { passive:true });
      window.addEventListener("resize", update);
      update();

      // mouse / pen drag-to-scroll (touch already scrolls natively)
      var isDown = false, moved = false, startX = 0, startLeft = 0;
      function release(e){
        if(!isDown) return;
        isDown = false;
        grid.classList.remove("is-dragging");
        try{ grid.releasePointerCapture(e.pointerId); }catch(err){}
      }
      grid.addEventListener("pointerdown", function(e){
        if(e.pointerType === "touch") return;
        if(grid.scrollWidth <= grid.clientWidth + 4) return;
        isDown = true; moved = false; startX = e.clientX; startLeft = grid.scrollLeft;
        grid.classList.add("is-dragging");
        try{ grid.setPointerCapture(e.pointerId); }catch(err){}
      });
      grid.addEventListener("pointermove", function(e){
        if(!isDown) return;
        var dx = e.clientX - startX;
        if(Math.abs(dx) > 6) moved = true;
        grid.scrollLeft = startLeft - dx;
      });
      grid.addEventListener("pointerup", release);
      grid.addEventListener("pointercancel", release);
      grid.addEventListener("click", function(e){
        if(moved){ e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    });
  }

  /* ---------- Sticky ATC ---------- */
  function initStickyAtc(){
    var bar = $("#StickyAtc"); var watch = $("#ProductBuyBox");
    if(!bar || !watch) return;
    var on = function(){ var r = watch.getBoundingClientRect(); bar.classList.toggle("show", r.bottom < 60); };
    on(); window.addEventListener("scroll", on, { passive:true });
    var btn = $("[data-sticky-add]", bar);
    if(btn && !btn.dataset.bound){
      btn.dataset.bound = "1";
      btn.addEventListener("click", function(){
        var f = $("#ProductForm");
        if(!f) return;
        if(f.requestSubmit){ f.requestSubmit(); }
        else { f.dispatchEvent(new Event("submit", { cancelable:true, bubbles:true })); }
      });
    }
  }

  /* ---------- Hero image thumbnails ---------- */
  function initHeroThumbs(){
    $$("[data-hero-thumbs]").forEach(function(wrap){
      if(wrap.dataset.bound) return; wrap.dataset.bound = "1";
      var media = wrap.parentNode.querySelector(".hero__media-img");
      var main = media ? media.querySelector("img") : null;
      if(!main) return;
      wrap.addEventListener("click", function(e){
        var btn = e.target.closest(".hero__thumb"); if(!btn) return;
        $$(".hero__thumb", wrap).forEach(function(t){ t.classList.remove("active"); });
        btn.classList.add("active");
        main.removeAttribute("srcset");
        main.src = btn.getAttribute("data-full");
      });
    });
  }

  /* ---------- Live viewer count ---------- */
  function initViewing(){
    $$("[data-viewing]").forEach(function(el){
      if(el.dataset.bound) return; el.dataset.bound = "1";
      var min = parseInt(el.getAttribute("data-min") || "14", 10);
      var max = parseInt(el.getAttribute("data-max") || "58", 10);
      if(max < min){ var t = max; max = min; min = t; }
      function rnd(){ return Math.floor(min + Math.random() * (max - min + 1)); }
      el.textContent = rnd();
      setInterval(function(){
        var cur = parseInt(el.textContent, 10) || rnd();
        var next = cur + (Math.random() < 0.5 ? -1 : 1);
        el.textContent = Math.min(max, Math.max(min, next));
      }, 5200);
    });
  }

  /* ---------- Discount popup ---------- */
  function initPopup(){
    var modal = $("#DiscountPopup");
    if(!modal || !T.popup || !T.popup.enabled) return;
    var KEY = "mt_popup_seen";
    try{ if(localStorage.getItem(KEY)){ return; } }catch(err){}
    var fired = false, timer;
    function cleanup(){ clearTimeout(timer); document.removeEventListener("mouseout", onLeave); }
    function show(){ if(fired) return; fired = true; modal.classList.add("show"); cleanup(); }
    function close(){ modal.classList.remove("show"); try{ localStorage.setItem(KEY, "1"); }catch(err){} }
    function onLeave(e){ if(e.clientY <= 0 && !e.relatedTarget) show(); }
    timer = setTimeout(show, (T.popup.delay || 12000));
    document.addEventListener("mouseout", onLeave);
    modal.addEventListener("click", function(e){
      if(e.target === modal || e.target.closest("[data-popup-close]")){ close(); }
      var copyBtn = e.target.closest("[data-popup-copy]");
      if(copyBtn){ var code = copyBtn.getAttribute("data-code"); try{ navigator.clipboard.writeText(code); }catch(err){} copyBtn.textContent = "Copied"; setTimeout(function(){ copyBtn.textContent = "Copy"; }, 1800); }
    });
  }

  /* ---------- Reviews load more ---------- */
  function initReviews(){
    $$("[data-reviews-more]").forEach(function(btn){
      if(btn.dataset.bound) return; btn.dataset.bound = "1";
      btn.addEventListener("click", function(){
        var wall = document.querySelector("[data-reviews-wall]");
        if(!wall) return;
        $$(".review-card.is-hidden", wall).slice(0, 6).forEach(function(c){ c.classList.remove("is-hidden"); });
        if($$(".review-card.is-hidden", wall).length === 0){ btn.style.display = "none"; }
      });
    });
  }

  /* ---------- Count up ---------- */
  function initCountUp(){
    if(!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(e){
        if(!e.isIntersecting) return; io.unobserve(e.target);
        var el = e.target, to = parseFloat(el.getAttribute("data-count")), suf = el.getAttribute("data-suffix")||"", start = performance.now(), dur = 1400;
        function tick(now){ var p = Math.min(1,(now-start)/dur), eased = 1-Math.pow(1-p,3); el.textContent = Math.round(to*eased).toLocaleString() + suf; if(p<1) requestAnimationFrame(tick); }
        requestAnimationFrame(tick);
      });
    }, { threshold:.4 });
    $$("[data-count]").forEach(function(el){ io.observe(el); });
  }

  /* ---------- helpers ---------- */
  function escapeHtml(s){ return (s||"").replace(/[&<>"']/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;"}[c]; }); }
  function icon(name){
    var I = {
      bag:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 8h12l1 12H5L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
      plus:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 5v14M5 12h14"/></svg>',
      minus:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M5 12h14"/></svg>'
    };
    return I[name]||"";
  }

  /* ---------- init ---------- */
  function init(){
    initReveal(); initHeader(); initMenu(); initCart(); initProductForm();
    initProductBuy(); initGallery(); initBeforeAfter(); initMobileScrollers(); initStickyAtc(); initPopup(); initCountUp(); initReviews(); initViewing(); initHeroThumbs();
    // re-run reveal after Shopify section reloads in editor
    document.addEventListener("shopify:section:load", function(){ initReveal(); initBeforeAfter(); initMobileScrollers(); initGallery(); initProductForm(); initProductBuy(); initStickyAtc(); initCountUp(); initReviews(); initViewing(); initHeroThumbs(); });
  }
  if(document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", init); } else { init(); }
})();
